import { getSessionStore } from "../utils/sessionStore";
import { THEME } from "../utils/types";

interface StatChipProps {
  value: number;
  showArrow?: boolean;
  className?: string;
  formatValue?: string;
}
// Get appropriate color classes and background colors based on value and theme
export const getColorStyles = (value: number, isPositive: boolean, isDarkMode: boolean) => {
  if (value === 0) {
    return {
      color: "#326fd1",
      bgColor: "#d4e5ff",
    };
  }

  if (isPositive) {
    return {
      color: "#1da750",
      bgColor: isDarkMode ? "#37404C" : "#E4F8F0",
    };
  }

  return {
    color: "#d9342b",
    bgColor: isDarkMode ? "#3F3F3F" : "#FEE2E2",
  };
};

const StatusChip = ({ value, formatValue, showArrow = true, className = "" }: StatChipProps) => {
  const isDarkMode = getSessionStore("globalTheme") === THEME.DARK;

  // Determine if the value is positive or negative
  const isPositive = value >= 0;

  const { color, bgColor } = getColorStyles(value, isPositive, isDarkMode);

  // Get appropriate arrow component
  const showArrowIcon = () => {
    if (showArrow && value !== 0) {
      return (
        <i
          className={`pi ${isPositive ? "pi-arrow-up" : "pi-arrow-down"} mr-1`}
          style={{ fontSize: "0.56rem" }}
        />
      );
    }
    return null;
  };

  return (
    <span
      className={`inline-flex items-center justify-center px-1 py-1 rounded-full text-[10px] conthrax-font ${className}`}
      style={{ backgroundColor: bgColor, minWidth: "60px", color }}
    >
      {showArrowIcon()}
      {formatValue || value.toString()}
    </span>
  );
};

export default StatusChip;
